/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($){
  
  $('.matchHeightme').matchHeight({
    target: $('.principal-height')
  });

  $(window).on('load',function () {

    $(window).on('scroll',function () {
      var scroll = ($(window).scrollTop()/2);
      if($('.template-collection .ImageHero__Image').length) {
        $('.template-collection .ImageHero__Image').css('transform','translate3d(0px, '+scroll+'px, 0px)');
      }
    });

    setTimeout(function(){
        
      $('.product-customizer-select-wrap select[name="properties[Fonts]"]').on('change',function () {
        var val = $(this).val();
        $('.font-holder img').hide();
        $('.font-holder img[alt="'+val+'"]').show();
      });

      $('.product-customizer-select-wrap select[name="properties[Embroidery]"]').on('change',function () {
        var val_ = $(this).val();
        if(val_ == 'No - No Embroidery') {
          $('.font-holder').hide();
        } else {
          $('.font-holder').show();
        }
      });
      
    },1500);

    setTimeout(function(){
      $('.font-holder').detach().insertBefore('.product-customizer-option[data-option-id="330838"]');
    },2500);
    
  });
  
});